export const temp = {
   uri: "/data/order/temp3.php",
} as const;
